import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMegaphone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M20.664 3.477 8 8v7l.746.266-1.125 2.257c-.129.254-.2.536-.21.825a2.02 2.02 0 0 0 1.367 1.969l4.081 1.355a2.015 2.015 0 0 0 2.422-1l1.305-2.606 4.078 1.457c.152.051.313.07.473.047a.985.985 0 0 0 .75-.53.981.981 0 0 0 .113-.462V4.418c0-.156-.04-.316-.113-.461a1.006 1.006 0 0 0-1.223-.48Zm-1.016 2.636v10.762l-9.41-3.45V9.45l9.41-3.336m-6.152 13.664L9.41 18.414l1.235-2.469 4.043 1.442ZM4 15h2.375V8H3.898a2 2 0 0 0-1.996 2v3c0 .547.223 1.07.621 1.45.395.378.93.577 1.477.55Zm0 0"
	})
});
export default SvgMegaphone;
